import { Plural } from "@lingui/react/macro";
import { formatDuration } from "@/forms/AddActivity/activityDurationUtils";

export const DurationText = ({ duration }: { duration: number }) => {
  const { value, timeUnit } = formatDuration(duration);
  if (timeUnit === "hour") {
    return <Plural value={value} one="# timme" other="# timmar" />;
  }
  return <Plural value={value} one="# minut" other="# minuter" />;
};
